

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';

export default function AddLiquidacionForm() {
  const [formData, setFormData] = useState({
    id: '',
    sepulturaId: '',
    terceroId: '',
    tramiteId: '',
    tramiteTipo: '',
    fecha: '',
    concepto: '',
    importe: '',
    observaciones: '-',
    tasaId: '', // Nuevo campo para la tasa seleccionada
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [terceros, setTerceros] = useState([]);
  const [tasas, setTasas] = useState([]);
  const [searchTercero, setSearchTercero] = useState('');
  const [searchTasa, setSearchTasa] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const [tercerosResponse, tasasResponse, liquidacionesResponse] = await Promise.all([
          axios.get('/terceros'),
          axios.get('/tasas'),
          axios.get('/liquidaciones') // Consultar todas las liquidaciones
        ]);
        
        setTerceros(tercerosResponse.data);
        setTasas(tasasResponse.data);

        // Obtener el siguiente ID disponible
        const lastId = liquidacionesResponse.data.reduce((maxId, liquidacion) => 
          Math.max(maxId, liquidacion.id), 0);
        setFormData((prevData) => ({ ...prevData, id: lastId + 1 }));
      } catch (err) {
        console.error('Error fetching initial data:', err);
      }
    };

    fetchInitialData();
  }, []);




  /*
  useEffect(() => {
    const fetchTerceros = async () => {
      try {
        const response = await axios.get('/terceros');
        setTerceros(response.data);
      } catch (err) {
        console.error('Error fetching terceros:', err);
      }
    };
    const fetchTasas = async () => {
      try {
        const response = await axios.get('/tasas');
        setTasas(response.data);
      } catch (err) {
        console.error('Error fetching tasas:', err);
      }
    };

    fetchTerceros();
    fetchTasas();
  }, []);
*/



  const filteredTerceros = terceros.filter((tercero) =>
    tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase()) ||
    tercero.documento.toString().includes(searchTercero)
  );

  const filteredTasas = tasas.filter((tasa) =>
    tasa.descripcion.toLowerCase().includes(searchTasa.toLowerCase()) ||
    tasa.id.toString().includes(searchTasa)
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: '' });
  };

  const handleTerceroSelect = (e) => {
    setSearchTercero(e.target.value);
    setFormData({ ...formData, terceroId: e.target.value });
  };

 
const handleTasaSelect = (e) => {
  const selectedTasaId = e.target.value;
  const selectedTasa = tasas.find((tasa) => tasa.id.toString() === selectedTasaId);

  if (selectedTasa) {
    setFormData({
      ...formData,
      tasaId: selectedTasaId,
      tramiteTipo: selectedTasaId,
      tramiteId:selectedTasaId,
      importe: selectedTasa.importe.toString(),
      concepto: selectedTasa.descripcion, // Asignar el precio/importe al campo importe
    });
  }
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = {};
    if (!formData.id) validationErrors.id = 'El campo ID es obligatorio.';
    if (!formData.sepulturaId) validationErrors.sepulturaId = 'El campo Sepultura ID es obligatorio.';
    if (!formData.terceroId) validationErrors.terceroId = 'El campo Tercero ID es obligatorio.';
    if (!formData.tramiteId) validationErrors.tramiteId = 'El campo Trámite ID es obligatorio.';
    if (!formData.tramiteTipo) validationErrors.tramiteTipo = 'El campo Trámite Tipo es obligatorio.';
    if (!formData.fecha) validationErrors.fecha = 'El campo Fecha es obligatorio.';
    if (!formData.concepto) validationErrors.concepto = 'El campo Concepto es obligatorio.';
    if (!formData.importe) validationErrors.importe = 'El campo Importe es obligatorio.';
    if (!formData.observaciones) validationErrors.observaciones = 'El campo Observaciones es obligatorio.';
    if (!formData.tasaId) validationErrors.tasaId = 'El campo Tasa es obligatorio.';

    if (Object.keys(validationErrors).length === 0) {
      setIsLoading(true);
      try {
        await axios.post('/liquidaciones', {
          id: parseInt(formData.id, 10),
          sepulturaId: parseInt(formData.sepulturaId, 10),
          terceroId: formData.terceroId,
          tramiteId: parseInt(formData.tramiteId, 10),
          tramiteTipo: parseInt(formData.tramiteTipo, 10),
          fecha: formData.fecha,
          concepto: formData.concepto,
          importe: parseFloat(formData.importe),
          observaciones: formData.observaciones,
          tasaId: parseInt(formData.tasaId, 10),
        });
        navigate('/home/liquidaciones');
      } catch (err) {
        console.error('Error saving liquidación:', err);
        setErrors({ submit: 'Error al guardar la liquidación. Por favor, intente de nuevo.' });
      } finally {
        setIsLoading(false);
      }
    } else {
      setErrors(validationErrors);
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
  <h2 className="text-2xl font-semibold text-blue-700 mb-6">Añadir Nueva Liquidación</h2>
  <form onSubmit={handleSubmit} className="bg-blue-100 shadow-md rounded px-8 pt-6 pb-8 mb-4">
    <div className="grid grid-cols-2 gap-4">
      {Object.keys(formData).map((key) => (
        key !== 'terceroId' && key !== 'tasaId' && key !== 'tramiteTipo' ? (
          <div className="mb-4" key={key}>
            <label className="block text-blue-700 text-sm font-bold mb-2" htmlFor={key}>
              {key.charAt(0).toUpperCase() + key.slice(1)}
            </label>
            <input
              type={key === 'fecha' ? 'date' : 'text'}
              name={key}
              value={formData[key]}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              placeholder={`Ingrese ${key}`}
            />
          </div>
        ) : key === 'terceroId' ? (
          <div className="mb-4 col-span-2" key={key}>
            <label className="block text-blue-700 text-sm font-bold mb-2">Buscar por Tercero</label>
            <input
              type="text"
              placeholder="Buscar por Tercero"
              className="border p-2 rounded w-1/3"
              value={searchTercero}
              onChange={(e) => setSearchTercero(e.target.value)}
            />
            <select
              value={formData.terceroId}
              onChange={handleTerceroSelect}
              className="border p-2 rounded w-1/3"
            >
              <option value="">Seleccione un tercero</option>
              {filteredTerceros.map(tercero => (
                <option key={tercero.documento} value={tercero.documento}>
                  {tercero.nombre} - {tercero.documento}
                </option>
              ))}
            </select>
          </div>
        ) : null
      ))}

      {/* Trámite Tipo y Buscar por Tasa juntos en una fila */}
      <div className="mb-4 col-span-2 grid grid-cols-2 gap-4">
        <div className="flex-1">
          <label className="block text-blue-700 text-sm font-bold mb-2">Trámite Tipo</label>
          <input
            type="text"
            name="tramiteTipo"
            value={formData.tramiteTipo}
            onChange={handleChange}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            placeholder="Ingrese Trámite Tipo"
          />
        </div>
        <div className="flex-1">
          <label className="block text-blue-700 text-sm font-bold mb-2">Buscar por Tasa</label>
          <input
            type="text"
            placeholder="Buscar por Tasa"
            className="border p-2 rounded w-full mb-2"
            value={searchTasa}
            onChange={(e) => setSearchTasa(e.target.value)}
          />
          <select
            value={formData.tasaId}
            onChange={handleTasaSelect}
            className="border p-2 rounded w-full"
          >
            <option value="">Seleccione una tasa</option>
            {filteredTasas.map(tasa => (
              <option key={tasa.id} value={tasa.id}>
                {tasa.id} - {tasa.descripcion} - ${tasa.importe}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
    <button type="submit" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" disabled={isLoading}>
      {isLoading ? 'Guardando...' : 'Guardar Liquidación'}
    </button>
  </form>
</div>

  );
}

/* CORRECTO CON BUSQUEDA DE TERCERO Y TASA
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';

export default function AddLiquidacionForm() {
  const [formData, setFormData] = useState({
    id: '',
    sepulturaId: '',
    terceroId: '',
    tramiteId: '',
    tramiteTipo: '',
    fecha: '',
    concepto: '',
    importe: '',
    observaciones: '',
    tasaId: '', // Nuevo campo para la tasa seleccionada
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [terceros, setTerceros] = useState([]);
  const [tasas, setTasas] = useState([]);
  const [searchTercero, setSearchTercero] = useState('');
  const [searchTasa, setSearchTasa] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTerceros = async () => {
      try {
        const response = await axios.get('/terceros');
        setTerceros(response.data);
      } catch (err) {
        console.error('Error fetching terceros:', err);
      }
    };
    const fetchTasas = async () => {
      try {
        const response = await axios.get('/tasas');
        setTasas(response.data);
      } catch (err) {
        console.error('Error fetching tasas:', err);
      }
    };

    fetchTerceros();
    fetchTasas();
  }, []);

  const filteredTerceros = terceros.filter((tercero) =>
    tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase()) ||
    tercero.documento.toString().includes(searchTercero)
  );

  const filteredTasas = tasas.filter((tasa) =>
    tasa.descripcion.toLowerCase().includes(searchTasa.toLowerCase()) ||
    tasa.id.toString().includes(searchTasa)
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: '' });
  };

  const handleTerceroSelect = (e) => {
    setSearchTercero(e.target.value);
    setFormData({ ...formData, terceroId: e.target.value });
  };

 
const handleTasaSelect = (e) => {
  const selectedTasaId = e.target.value;
  const selectedTasa = tasas.find((tasa) => tasa.id.toString() === selectedTasaId);

  if (selectedTasa) {
    setFormData({
      ...formData,
      tasaId: selectedTasaId,
      tramiteTipo: selectedTasaId,
      importe: selectedTasa.importe.toString(), // Asignar el precio/importe al campo importe
    });
  }
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = {};
    if (!formData.id) validationErrors.id = 'El campo ID es obligatorio.';
    if (!formData.sepulturaId) validationErrors.sepulturaId = 'El campo Sepultura ID es obligatorio.';
    if (!formData.terceroId) validationErrors.terceroId = 'El campo Tercero ID es obligatorio.';
    if (!formData.tramiteId) validationErrors.tramiteId = 'El campo Trámite ID es obligatorio.';
    if (!formData.tramiteTipo) validationErrors.tramiteTipo = 'El campo Trámite Tipo es obligatorio.';
    if (!formData.fecha) validationErrors.fecha = 'El campo Fecha es obligatorio.';
    if (!formData.concepto) validationErrors.concepto = 'El campo Concepto es obligatorio.';
    if (!formData.importe) validationErrors.importe = 'El campo Importe es obligatorio.';
    if (!formData.observaciones) validationErrors.observaciones = 'El campo Observaciones es obligatorio.';
    if (!formData.tasaId) validationErrors.tasaId = 'El campo Tasa es obligatorio.';

    if (Object.keys(validationErrors).length === 0) {
      setIsLoading(true);
      try {
        await axios.post('/liquidaciones', {
          id: parseInt(formData.id, 10),
          sepulturaId: parseInt(formData.sepulturaId, 10),
          terceroId: formData.terceroId,
          tramiteId: parseInt(formData.tramiteId, 10),
          tramiteTipo: parseInt(formData.tramiteTipo, 10),
          fecha: formData.fecha,
          concepto: formData.concepto,
          importe: parseFloat(formData.importe),
          observaciones: formData.observaciones,
          tasaId: parseInt(formData.tasaId, 10),
        });
        navigate('/home/liquidaciones');
      } catch (err) {
        console.error('Error saving liquidación:', err);
        setErrors({ submit: 'Error al guardar la liquidación. Por favor, intente de nuevo.' });
      } finally {
        setIsLoading(false);
      }
    } else {
      setErrors(validationErrors);
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h2 className="text-2xl font-semibold text-blue-700 mb-6">Añadir Nueva Liquidación</h2>
      <form onSubmit={handleSubmit} className="bg-blue-100 shadow-md rounded px-8 pt-6 pb-8 mb-4">
        <div className="grid grid-cols-2 gap-4">
          {Object.keys(formData).map((key) => (
            key !== 'terceroId' && key !== 'tasaId' ? (
              <div className="mb-4" key={key}>
                <label className="block text-blue-700 text-sm font-bold mb-2" htmlFor={key}>
                  {key.charAt(0).toUpperCase() + key.slice(1)}
                </label>
                <input
                  type={key === 'fecha' ? 'date' : 'text'}
                  name={key}
                  value={formData[key]}
                  onChange={handleChange}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  placeholder={`Ingrese ${key}`}
                />
              </div>
            ) : key === 'terceroId' ? (
              <div className="mb-4" key={key}>
                <label className="block text-blue-700 text-sm font-bold mb-2">Buscar por Tercero</label>
                <input
                  type="text"
                  placeholder="Buscar por Tercero"
                  className="border p-2 rounded w-1/3"
                  value={searchTercero}
                  onChange={(e) => setSearchTercero(e.target.value)}
                />
                <select
                  value={formData.terceroId}
                  onChange={handleTerceroSelect}
                  className="border p-2 rounded w-1/3"
                >
                  <option value="">Seleccione un tercero</option>
                  {filteredTerceros.map(tercero => (
                    <option key={tercero.documento} value={tercero.documento}>
                      {tercero.nombre} - {tercero.documento}
                    </option>
                  ))}
                </select>
              </div>
            ) : (
              <div className="mb-4" key={key}>
                <label className="block text-blue-700 text-sm font-bold mb-2">Buscar por Tasa</label>
                <input
                  type="text"
                  placeholder="Buscar por Tasa"
                  className="border p-2 rounded w-1/3"
                  value={searchTasa}
                  onChange={(e) => setSearchTasa(e.target.value)}
                />
                <select
                  value={formData.tasaId}
                  onChange={handleTasaSelect}
                  className="border p-2 rounded w-1/3"
                >
                  <option value="">Seleccione una tasa</option>
                  {filteredTasas.map(tasa => (
                    <option key={tasa.id} value={tasa.id}>
                      {tasa.id} - {tasa.descripcion} - ${tasa.importe}
                    </option>
                  ))}
                </select>
              </div>
            )
          ))}
        </div>
        <button type="submit" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" disabled={isLoading}>
          {isLoading ? 'Guardando...' : 'Guardar Liquidación'}
        </button>
      </form>
    </div>
  );
}
*/

/* CORRECTO CON BUSQUEDA DE TERCERO
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';

export default function AddLiquidacionForm() {
  const [formData, setFormData] = useState({
    id: '',
    sepulturaId: '',
    terceroId: '',
    tramiteId: '',
    tramiteTipo: '',
    fecha: '',
    concepto: '',
    importe: '',
    observaciones: ''
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [terceros, setTerceros] = useState([]);
  const [searchTercero, setSearchTercero] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTerceros = async () => {
      try {
        const response = await axios.get('/terceros');
        setTerceros(response.data);
      } catch (err) {
        console.error('Error fetching terceros:', err);
      }
    };
    fetchTerceros();
  }, []);

  const filteredTerceros = terceros.filter(tercero =>
    tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase()) ||
    tercero.documento.toString().includes(searchTercero)
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: '' });
  };

  const handleTerceroSelect = (e) => {
    setSearchTercero(e.target.value);
    setFormData({ ...formData, terceroId: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = {};
    if (!formData.id) validationErrors.id = 'El campo ID es obligatorio.';
    if (!formData.sepulturaId) validationErrors.sepulturaId = 'El campo Sepultura ID es obligatorio.';
    if (!formData.terceroId) validationErrors.terceroId = 'El campo Tercero ID es obligatorio.';
    if (!formData.tramiteId) validationErrors.tramiteId = 'El campo Trámite ID es obligatorio.';
    if (!formData.tramiteTipo) validationErrors.tramiteTipo = 'El campo Trámite Tipo es obligatorio.';
    if (!formData.fecha) validationErrors.fecha = 'El campo Fecha es obligatorio.';
    if (!formData.concepto) validationErrors.concepto = 'El campo Concepto es obligatorio.';
    if (!formData.importe) validationErrors.importe = 'El campo Importe es obligatorio.';
    if (!formData.observaciones) validationErrors.observaciones = 'El campo Observaciones es obligatorio.';

    if (Object.keys(validationErrors).length === 0) {
      setIsLoading(true);
      try {
        await axios.post('/liquidaciones', {
          id: parseInt(formData.id, 10),
          sepulturaId: parseInt(formData.sepulturaId, 10),
          terceroId: formData.terceroId,
          tramiteId: parseInt(formData.tramiteId, 10),
          tramiteTipo: parseInt(formData.tramiteTipo, 10),
          fecha: formData.fecha,
          concepto: formData.concepto,
          importe: parseFloat(formData.importe),
          observaciones: formData.observaciones
        });
        navigate('/home/liquidaciones');
      } catch (err) {
        console.error('Error saving liquidación:', err);
        setErrors({ submit: 'Error al guardar la liquidación. Por favor, intente de nuevo.' });
      } finally {
        setIsLoading(false);
      }
    } else {
      setErrors(validationErrors);
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h2 className="text-2xl font-semibold text-blue-700 mb-6">Añadir Nueva Liquidación</h2>
      <form onSubmit={handleSubmit} className="bg-blue-100 shadow-md rounded px-8 pt-6 pb-8 mb-4">
        <div className="grid grid-cols-2 gap-4">
          {Object.keys(formData).map((key) => (
            key !== 'terceroId' ? (
              <div className="mb-4" key={key}>
                <label className="block text-blue-700 text-sm font-bold mb-2" htmlFor={key}>
                  {key.charAt(0).toUpperCase() + key.slice(1)}
                </label>
                <input
                  type={key === 'fecha' ? 'date' : 'text'}
                  name={key}
                  value={formData[key]}
                  onChange={handleChange}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  placeholder={`Ingrese ${key}`}
                />
              </div>
            ) : (
              <div className="mb-4" key={key}>
                <label className="block text-blue-700 text-sm font-bold mb-2">Buscar por Tercero</label>
                <input
                  type="text"
                  placeholder="Buscar por Tercero"
                  className="border p-2 rounded w-1/3"
                  value={searchTercero}
                  onChange={(e) => setSearchTercero(e.target.value)}
                />
                <select
                  value={searchTercero}
                  onChange={handleTerceroSelect}
                  className="border p-2 rounded w-1/3"
                >
                  <option value="">Seleccione un tercero</option>
                  {filteredTerceros.map(tercero => (
                    <option key={tercero.documento} value={tercero.documento}>
                      {tercero.nombre} - {tercero.documento}
                    </option>
                  ))}
                </select>
              </div>
            )
          ))}
        </div>
        <button type="submit" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" disabled={isLoading}>
          {isLoading ? 'Guardando...' : 'Guardar Liquidación'}
        </button>
      </form>
    </div>
  );
}
*/
/* CORRECTO
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';

export default function AddLiquidacionForm() {
  const [formData, setFormData] = useState({
    id: '',
    sepulturaId: '',
    terceroId: '',
    tramiteId: '',
    tramiteTipo: '',
    fecha: '',
    concepto: '',
    importe: '',
    observaciones: ''
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: '' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const validationErrors = {};
    if (!formData.id) validationErrors.id = 'El campo ID es obligatorio.';
    if (!formData.sepulturaId) validationErrors.sepulturaId = 'El campo Sepultura ID es obligatorio.';
    if (!formData.terceroId) validationErrors.terceroId = 'El campo Tercero ID es obligatorio.';
    if (!formData.tramiteId) validationErrors.tramiteId = 'El campo Trámite ID es obligatorio.';
    if (!formData.tramiteTipo) validationErrors.tramiteTipo = 'El campo Trámite Tipo es obligatorio.';
    if (!formData.fecha) validationErrors.fecha = 'El campo Fecha es obligatorio.';
    if (!formData.concepto) validationErrors.concepto = 'El campo Concepto es obligatorio.';
    if (!formData.importe) validationErrors.importe = 'El campo Importe es obligatorio.';
    if (!formData.observaciones) validationErrors.observaciones = 'El campo Observaciones es obligatorio.';

    if (Object.keys(validationErrors).length === 0) {
      setIsLoading(true);
      try {
        await axios.post('/liquidaciones', {
          id: parseInt(formData.id, 10),
          sepulturaId: parseInt(formData.sepulturaId, 10),
          terceroId: formData.terceroId,
          tramiteId: parseInt(formData.tramiteId, 10),
          tramiteTipo: parseInt(formData.tramiteTipo, 10),
          fecha: formData.fecha,
          concepto: formData.concepto,
          importe: parseFloat(formData.importe),
          observaciones: formData.observaciones
        });
        navigate('/home/liquidaciones');
      } catch (err) {
        console.error('Error saving liquidación:', err);
        setErrors({ submit: 'Error al guardar la liquidación. Por favor, intente de nuevo.' });
      } finally {
        setIsLoading(false);
      }
    } else {
      setErrors(validationErrors);
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h2 className="text-2xl font-semibold text-blue-700 mb-6">Añadir Nueva Liquidación</h2>
      <form onSubmit={handleSubmit} className="bg-blue-100 shadow-md rounded px-8 pt-6 pb-8 mb-4">
        <div className="grid grid-cols-2 gap-4">
          {Object.keys(formData).map((key) => (
            <div className="mb-4" key={key}>
              <label className="block text-blue-700 text-sm font-bold mb-2" htmlFor={key}>
                {key.charAt(0).toUpperCase() + key.slice(1)}
              </label>
              <input
                type={key === 'fecha' ? 'date' : 'text'}
                name={key}
                value={formData[key]}
                onChange={handleChange}
                className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors[key] ? 'border-red-500' : ''}`}
                placeholder={`Ingrese ${key}`}
              />
              {errors[key] && <p className="text-red-500 text-xs italic">{errors[key]}</p>}
            </div>
          ))}
        </div>
        {errors.submit && <p className="text-red-500 text-xs italic mb-4">{errors.submit}</p>}
        <div className="flex items-center justify-between">
          <button
            type="submit"
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            disabled={isLoading}
          >
            {isLoading ? 'Guardando...' : 'Guardar Liquidación'}
          </button>
        </div>
      </form>
    </div>
  );
}

*/

/*
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';

export default function AddLiquidacionForm() {
  const [formData, setFormData] = useState({
    id: '',
    sepulturaId: '',
    terceroId: '',
    tramiteId: '',
    tramiteTipo: '',
    fecha: '',
    concepto: '',
    importe: '',
    observaciones: ''
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: '' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const validationErrors = {};
    if (!formData.id) validationErrors.id = 'El campo ID es obligatorio.';
    if (!formData.sepulturaId) validationErrors.sepulturaId = 'El campo Sepultura ID es obligatorio.';
    if (!formData.terceroId) validationErrors.terceroId = 'El campo Tercero ID es obligatorio.';
    if (!formData.tramiteId) validationErrors.tramiteId = 'El campo Trámite ID es obligatorio.';
    if (!formData.tramiteTipo) validationErrors.tramiteTipo = 'El campo Trámite Tipo es obligatorio.';
    if (!formData.fecha) validationErrors.fecha = 'El campo Fecha es obligatorio.';
    if (!formData.concepto) validationErrors.concepto = 'El campo Concepto es obligatorio.';
    if (!formData.importe) validationErrors.importe = 'El campo Importe es obligatorio.';
    if (!formData.observaciones) validationErrors.observaciones = 'El campo Observaciones es obligatorio.';

    if (Object.keys(validationErrors).length === 0) {
      setIsLoading(true);
      try {
        await axios.post('/liquidaciones', {
          id: parseInt(formData.id, 10),
          sepulturaId: parseInt(formData.sepulturaId, 10),
          terceroId: formData.terceroId,
          tramiteId: parseInt(formData.tramiteId, 10),
          tramiteTipo: parseInt(formData.tramiteTipo, 10),
          fecha: formData.fecha,
          concepto: formData.concepto,
          importe: parseFloat(formData.importe),
          observaciones: formData.observaciones
        });
        navigate('/home/liquidaciones');
      } catch (err) {
        console.error('Error saving liquidación:', err);
        setErrors({ submit: 'Error al guardar la liquidación. Por favor, intente de nuevo.' });
      } finally {
        setIsLoading(false);
      }
    } else {
      setErrors(validationErrors);
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h2 className="text-2xl font-semibold mb-6">Añadir Nueva Liquidación</h2>
      <form onSubmit={handleSubmit} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
        {Object.keys(formData).map((key) => (
          <div className="mb-4" key={key}>
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={key}>
              {key.charAt(0).toUpperCase() + key.slice(1)}
            </label>
            <input
              type={key === 'fecha' ? 'date' : 'text'}
              name={key}
              value={formData[key]}
              onChange={handleChange}
              className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors[key] ? 'border-red-500' : ''}`}
              placeholder={`Ingrese ${key}`}
            />
            {errors[key] && <p className="text-red-500 text-xs italic">{errors[key]}</p>}
          </div>
        ))}
        {errors.submit && <p className="text-red-500 text-xs italic mb-4">{errors.submit}</p>}
        <div className="flex items-center justify-between">
          <button
            type="submit"
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            disabled={isLoading}
          >
            {isLoading ? 'Guardando...' : 'Guardar Liquidación'}
          </button>
        </div>
      </form>
    </div>
  );
}
*/